export default class ComponentNotDefinedError extends Error {
    constructor(
        public componentKind: string,
        public componentName: string,
        ...args: any[]
    ) {
        super(
            `Component of kind '${componentKind}' with name '${componentName}' is not defined.`,
            ...args
        );
        this.name = 'ComponentNotDefinedError';
    }
}
